import React from 'react';
import Loading from '../Loading';

const MissionCardLoading = () => {
  return <Loading style={{ backgroundColor: 'rgba(255,255,255,0.8)', zIndex: 1000, top: 0, left: 0 }} />;
};

export default MissionCardLoading;
